/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TeamInCompanyInTokenDto
 */
export interface TeamInCompanyInTokenDto {
    /**
     * 
     * @type {string}
     * @memberof TeamInCompanyInTokenDto
     */
    companyId: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof TeamInCompanyInTokenDto
     */
    teamNames: Array<string>;
}

/**
 * Check if a given object implements the TeamInCompanyInTokenDto interface.
 */
export function instanceOfTeamInCompanyInTokenDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "companyId" in value;
    isInstance = isInstance && "teamNames" in value;

    return isInstance;
}

export function TeamInCompanyInTokenDtoFromJSON(json: any): TeamInCompanyInTokenDto {
    return TeamInCompanyInTokenDtoFromJSONTyped(json, false);
}

export function TeamInCompanyInTokenDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TeamInCompanyInTokenDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'companyId': json['companyId'],
        'teamNames': json['teamNames'],
    };
}

export function TeamInCompanyInTokenDtoToJSON(value?: TeamInCompanyInTokenDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'companyId': value.companyId,
        'teamNames': value.teamNames,
    };
}

